<script>
  /**
   * @typedef {Object} Props
   * @property {string} [width]
   * @property {string} [color]
   * @property {string} [marginLeft]
   * @property {string} [marginRight]
   * @property {string} [marginTop]
   * @property {string} [marginBottom]
   * @property {string} [height]
   */

  /** @type {Props} */
  let {
    width = '539px',
    color = '#e8e8e9',
    marginLeft = '1.5rem',
    marginRight = '1.2rem',
    marginTop = '1.5rem',
    marginBottom = '0rem',
    height = ''
  } = $props();
</script>

<style>
  .separator {
    width: var(--width);
    height: var(--height);
    border: 1px solid var(--color);
    background: var(--color);
    margin-left: var(--marginLeft);
    margin-right: var(--marginRight);
    margin-top: var(--marginTop);
    margin-bottom: var(--marginBottom);
  }
</style>

<div
  class="separator"
  data-cy="drawer-separator"
  style="
      --color: {color};
      --width: {width};
      --height: {height};
      --marginLeft: {marginLeft};
      --marginRight: {marginRight};
      --marginTop: {marginTop};
      --marginBottom: {marginBottom};"
></div>
